import React from 'react';
import { Box } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { sizes } from 'src/styles/Media.styled';
import { StyledTextDiv } from 'src/pages/reportUsage/utils/reportUsage.styled';
import { isIpad } from 'src/utils/util';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const useStyles = makeStyles(() => ({
    paper: {
        padding: '13px 17px 13px 15px',
    },
}));

const HeaderTemplate = () => {
    const {t} = useTranslation();
    const classes = useStyles();
    const winWidth = window.innerWidth;
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );
    const isMobileView = winWidth <= sizes.mobileDevice;
    const isDesktopView = winWidth >= sizes.mediumDevice;
    const iPad = isIpad();
    return (
        <React.Fragment>
            <Box
                className={classes.paper}
                my={1}
                bgcolor={'#ffffff'}
                style={{
                    height: '48px',
                    borderRadius: '6px 6px 0px 0px',
                    background: '#FFFFFF 0% 0% no-repeat padding-box',
                    boxShadow: '0px 3px 2px #00000029',
                    border: '1px solid #DCDCDC',
                }}
            >
                <Grid
                    container
                    alignItems={'flex-start'}
                    justifyContent={'space-between'}
                >
                    {!isMobileView && !iPad && (
                        <Grid item lg={3} md={3} sm={6}>
                            <StyledTextDiv opacity={isCondensedView ? '1' : '0.7'}>
                                {t('reportUsage.review.discrepancy.RowHeaderDesktop.itemDescription')}
                            </StyledTextDiv>
                        </Grid>
                    )}
                    <Grid item lg={9} md={9} sm={6}>
                        <HeaderItemContainer>
                            {isDesktopView && (
                                <StyledTextDiv opacity={isCondensedView ? '1' : '0.7'}>{t('consignment.itemList.uom')}</StyledTextDiv>
                            )}
                            <StyledTextDiv
                                opacity={isCondensedView ? '1' : '0.7'}
                                textAlign={
                                    !isDesktopView && !isMobileView && 'end'
                                }
                            >
                                {t('common.qty')}
                            </StyledTextDiv>
                            {isDesktopView && (
                                <StyledTextDiv opacity={isCondensedView ? '1' : '0.7'}>
                                    {t('reportUsage.record.priceOverride.PriceOverrideTable.discount')}
                                </StyledTextDiv>
                            )}

                            <StyledTextDiv
                                opacity={isCondensedView ? '1' : '0.7'}
                                textAlign={!isDesktopView && 'end'}
                            >
                                {t('equity.submit.unitPrice')}
                            </StyledTextDiv>

                            <StyledTextDiv
                                opacity={isCondensedView ? '1' : '0.7'}
                                textAlign={!isDesktopView && 'end'}
                            >
                                {t('equity.submit.extPrice')}
                            </StyledTextDiv>
                        </HeaderItemContainer>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    );
};

export default HeaderTemplate;

export const HeaderItemContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;
